import React from 'react';
import { ArrowRight, Linkedin, Facebook, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-dark text-white pt-20 pb-8 px-6 md:px-12 border-t-4 border-primary" data-id="element-57">
      <div className="max-w-7xl mx-auto" data-id="element-58">
        {/* Top Section: CTA */}
        <div className="flex flex-col md:flex-row justify-between items-center pb-16 border-b border-gray-800 mb-12 gap-8" data-id="element-59">
          <h2 className="text-5xl md:text-7xl font-bold uppercase tracking-tight" data-id="element-60">
            LET'S WORK TOGETHER
          </h2>
          <button className="btn-white text-dark w-fit group flex-shrink-0" data-id="element-61">
            CONTACT US
            <div className="bg-primary text-white rounded-full p-1 group-hover:bg-primary-hover transition-colors" data-id="element-62">
              <ArrowRight size={16} data-id="element-63" />
            </div>
          </button>
        </div>

        {/* Bottom Section: Links & Info */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-64">
          {/* Logo & Links */}
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-65">
            <img src="https://static.wixstatic.com/media/b4bd31_e82dc880fa7046a89801e77cf431b6c8~mv2.avif/v1/fill/w_98,h_148,al_c,lg_1,q_80,enc_avif,quality_auto/B%26D.avif" alt="B&D Contracting" className="h-14 w-auto object-contain" data-id="element-66" />
            <div className="flex flex-wrap justify-center gap-6 font-heading font-semibold tracking-wider text-sm text-gray-400" data-id="element-67">
              <a href="#" className="hover:text-primary transition-colors" data-id="element-68">
                HOME
              </a>
              <a href="#" className="hover:text-primary transition-colors" data-id="element-69">
                FIND A JOB
              </a>
              <a href="#" className="hover:text-primary transition-colors" data-id="element-70">
                ABOUT US
              </a>
              <a href="#" className="hover:text-primary transition-colors" data-id="element-71">
                CONTACT
              </a>
            </div>
          </div>

          {/* Socials */}
          <div className="flex items-center gap-4" data-id="element-72">
            <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary transition-colors" data-id="element-73">
              <Linkedin size={20} data-id="element-74" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary transition-colors" data-id="element-75">
              <Facebook size={20} data-id="element-76" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary transition-colors" data-id="element-77">
              <Instagram size={20} data-id="element-78" />
            </a>
          </div>

          {/* Copyright */}
          <div className="text-gray-500 text-sm text-center md:text-right" data-id="element-79">
            © {new Date().getFullYear()} BND Contracting. All rights reserved.
          </div>
        </div>
      </div>
    </footer>;
}